import React, { Component, Fragment } from 'react';
import classes from './GenderStep.module.css';
import strings from '../../../../../assets/localization';
import config from '../../../../../constants/config';
import RadioGroup from '../../../../UI/RadioGroup/RadioGroup';
import StepHeader from '../StepHeader/StepHeader';
import Button from '../../../../UI/Button/Button';
import Spinner from '../../../../UI/Spinner/Spinner';
import { isEmpty } from '../../../../../assets/helpers/utils';

const { GENDER_ONE, GENDER_TWO, GENDER_OTHER, GENDER_CONFIG_ORDER } = config;

export default class GenderStep extends Component {
  constructor(props) {
    super(props);

    this.hiddenOptionsIndex = null;
    this.allOptions = [];

    // all mainstream single combinations
    this.allMainstreamCombinations = [
      { gender: 1, seeking: [1] }, // Man looking for Man
      { gender: 1, seeking: [2] }, // Man looking for Woman
      { gender: 2, seeking: [1] }, // Woman looking for Man
      { gender: 2, seeking: [2] }, // Woman looking for Woman
    ];

    this.state = {
      options: [],
      selectedValue: 0,
      showMoreOptions: false,
      areGendersSet: false,
    };
  }

  componentDidUpdate(prevProps) {
    // Handle gender API configuration and setup genders
    if (
      this.props.getConfig.status === 'success' &&
      !this.state.areGendersSet &&
      this.props.gender !== null &&
      this.props.seeking !== null
    ) {
      let [selectedValue, options, showMoreOptions] = this._setupGenders();
      this.setState({
        selectedValue,
        options,
        showMoreOptions,
        areGendersSet: true,
      });
    }

    //  Handle gender API config data load and preselected gender URL
    if (
      prevProps.genderApiConfigDataLodaded !==
        this.props.genderApiConfigDataLodaded &&
      this.props.genderApiConfigDataLodaded === true &&
      this.props.isGenderUrlPreselected === true
    ) {
      if (this.props.genderAndSeekingSelectedValue >= this.hiddenOptionsIndex) {
        this._addMoreOptions();
      }
      this.setState({
        selectedValue:
          this.props.genderAndSeekingSelectedValue < 0
            ? 0
            : this.props.genderAndSeekingSelectedValue,
      });
    }

    //  Handle changes to gender and seeking selected value
    if (
      prevProps.genderAndSeekingSelectedValue !==
        this.props.genderAndSeekingSelectedValue &&
      this.props.genderApiConfigDataLodaded === true &&
      this.props.isGenderUrlPreselected === true
    ) {
      if (this.props.genderAndSeekingSelectedValue >= this.hiddenOptionsIndex) {
        this._addMoreOptions();
      }
      this.setState({
        selectedValue:
          this.props.genderAndSeekingSelectedValue < 0
            ? 0
            : this.props.genderAndSeekingSelectedValue,
      });
    }

    //  Handle updates to selected value when it changes
    if (
      prevProps.genderAndSeekingSelectedValue !==
      this.props.genderAndSeekingSelectedValue
    ) {
      this.setState({
        selectedValue:
          this.props.genderAndSeekingSelectedValue < 0
            ? 0
            : this.props.genderAndSeekingSelectedValue,
      });
    }

    // Handle getConfig response changes
    if (
      prevProps.getConfig.status !== this.props.getConfig.status &&
      this.props.getConfig.status === 'success'
    ) {
      let [selectedValue, options, showMoreOptions] = this._setupGenders();
      this.setState({
        selectedValue,
        options,
        showMoreOptions,
        areGendersSet: true,
      });
    }
  }

  _setupGenders = () => {
    const { genderAndSeekingSelectedValue, gender, seeking } = this.props;

    if (this.props.getConfig.status !== 'success') {
      return [0, [], false];
    }
    const {
      genders_singular: gendersSingular,
      genders_seeking_stats: genderStats,
    } = this.props.getConfig.response;

    let showMoreOptions;
    let optionsArray = [];

    if (GENDER_OTHER || GENDER_CONFIG_ORDER) {
      let arr = [
        ...config.GENDER_SEEKING_SIGNUP_LOGIN.visibleOptions,
        ...config.GENDER_SEEKING_SIGNUP_LOGIN.moreOptions,
      ];
      optionsArray = arr.map((e, i) => {
        let genderId = parseInt(e.split('_')[0], 10);
        let seekingId = parseInt(e.split('_')[1], 10);
        return {
          value: i,
          // text: getGender(genderId) + ' ' + strings.lookingFor + ' ' + getSeekingGender(seekingId),
          text:
            gendersSingular[genderId] +
            ' ' +
            strings.lookingFor +
            ' ' +
            gendersSingular[seekingId === 4 ? 3 : seekingId],
          gender: genderId,
          seeking: seekingId,
        };
      });
      this.allOptions = [...optionsArray];
      this.hiddenOptionsIndex =
        config.GENDER_SEEKING_SIGNUP_LOGIN.visibleOptions.length;
    } else {
      const allMainstreamCombinations = this.allMainstreamCombinations;

      // Process genderStats to get visible and more options
      const { visibleOptions, moreOptions } = this.processGenderStats(
        genderStats,
        allMainstreamCombinations,
        gendersSingular
      );

      // Combine options for toggling purposes
      optionsArray = [...visibleOptions, ...moreOptions];
      this.allOptions = [...optionsArray];

      // Update state
      this.setState({
        options: visibleOptions,
        allOptions: optionsArray,
        showMoreOptions: moreOptions.length > 0,
      });

      this.hiddenOptionsIndex = 2;
    }

    if (genderAndSeekingSelectedValue >= this.hiddenOptionsIndex) {
      showMoreOptions = false;
    } else {
      // set dynamically visible options
      optionsArray = optionsArray.filter(
        (obj, i) => i < this.hiddenOptionsIndex
      );
      showMoreOptions = true;
    }

    if (
      !this.props.isGenderUrlPreselected ||
      (this.props.isGenderUrlPreselected &&
        this.props.genderApiConfigDataLodaded)
    ) {
      return [
        genderAndSeekingSelectedValue < 0 ? 0 : genderAndSeekingSelectedValue,
        optionsArray,
        showMoreOptions,
      ];
    } else {
      return [0, optionsArray, showMoreOptions];
    }
  };

  processGenderStats = (
    genderStats,
    allMainstreamCombinations,
    gendersSingular
  ) => {
    // Step 1: Handle the case where genderStats is missing or empty
    if (!genderStats || isEmpty(genderStats)) {
      return {
        visibleOptions: [
          {
            value: 0,
            text: `${gendersSingular[GENDER_ONE]} ${strings.lookingFor} ${gendersSingular[GENDER_TWO]}`,
            gender: GENDER_ONE,
            seeking: GENDER_TWO,
          },
          {
            value: 1,
            text: `${gendersSingular[GENDER_TWO]} ${strings.lookingFor} ${gendersSingular[GENDER_ONE]}`,
            gender: GENDER_TWO,
            seeking: GENDER_ONE,
          },
        ],
        moreOptions: [
          {
            value: 2,
            text: `${gendersSingular[GENDER_ONE]} ${strings.lookingFor} ${gendersSingular[GENDER_ONE]}`,
            gender: GENDER_ONE,
            seeking: GENDER_ONE,
          },
          {
            value: 3,
            text: `${gendersSingular[GENDER_TWO]} ${strings.lookingFor} ${gendersSingular[GENDER_TWO]}`,
            gender: GENDER_TWO,
            seeking: GENDER_TWO,
          },
        ],
      };
    }

    // Step 2: Filter out entries with multiple seeking values and remove duplicates
    const uniqueKeys = new Set();
    const filteredData = genderStats
      .filter((item) => item.seeking.length === 1) // Only include single seeking values
      .filter((item) => {
        const key = `${item.gender}_${item.seeking[0]}`;
        if (uniqueKeys.has(key)) {
          return false; // Skip duplicates
        }
        uniqueKeys.add(key);
        return true;
      });

    // Step 3: Identify missing combinations and add them with freqency_weight = 0
    const existingKeys = new Set(
      filteredData.map((item) => `${item.gender}_${item.seeking[0]}`)
    );
    const missingCombinations = allMainstreamCombinations
      .filter(
        (combo) => !existingKeys.has(`${combo.gender}_${combo.seeking[0]}`)
      )
      .map((combo) => ({
        ...combo,
        freqency_weight: 0, // Assign low weight to missing combinations
      }));

    // Step 4: Combine filtered data with missing combinations
    const completeData = [...filteredData, ...missingCombinations];

    // Step 5: Split data into visible and non-visible options
    const visibleData = completeData.filter(
      (item) => item.gender !== item.seeking[0]
    ); // Different gender seeking
    const nonVisibleData = completeData.filter(
      (item) => item.gender === item.seeking[0]
    ); // Same gender seeking

    // Step 6: Sort both groups by frequency_weight in descending order
    const sortedVisibleData = visibleData.sort(
      (a, b) => b.freqency_weight - a.freqency_weight
    );
    const sortedNonVisibleData = nonVisibleData.sort(
      (a, b) => b.freqency_weight - a.freqency_weight
    );

    // Step 7: Map to options
    const visibleOptions = sortedVisibleData.map((item, index) => ({
      value: index,
      text: `${gendersSingular[item.gender]} ${strings.lookingFor} ${
        gendersSingular[item.seeking[0]]
      }`,
      gender: item.gender,
      seeking: item.seeking[0],
    }));

    const moreOptions = sortedNonVisibleData.map((item, index) => ({
      value: visibleOptions.length + index, // Continue indexing from visible options
      text: `${gendersSingular[item.gender]} ${strings.lookingFor} ${
        gendersSingular[item.seeking[0]]
      }`,
      gender: item.gender,
      seeking: item.seeking[0],
    }));

    return { visibleOptions, moreOptions };
  };

  setGenderAndSeeking = (value) => {
    const { options } = this.state;
    this.setState({ selectedValue: value });
    const index = options.findIndex((o) => o.value === value);
    const obj = options[index];
    this.props.setGenderAndSeeking(obj.gender, obj.seeking, value);
  };

  _addMoreOptions = () => {
    if (this.state.showMoreOptions) {
      const newOptions = [...this.allOptions];
      this.setState({ options: newOptions, showMoreOptions: false });
    }
  };

  render() {
    // console.log('RENDER Gender Step', this.state);

    let content = null;
    if (this.props.getConfig.status === 'success') {
      content = (
        // eslint-disable-next-line react/jsx-fragments
        <Fragment>
          <div className={classes.LeftText}>{strings.iAm}</div>
          <RadioGroup
            withCheckmark
            options={this.state.options}
            selected={this.state.selectedValue}
            radioClicked={this.setGenderAndSeeking}
          />
          {this.state.showMoreOptions ? (
            <div className={classes.ShowMore} onClick={this._addMoreOptions}>
              {strings.viewOtherOptions}
            </div>
          ) : null}
        </Fragment>
      );
    } else {
      content = (
        <div className={classes.SpinnerWrapper}>
          <Spinner size='Small' />
        </div>
      );
    }
    return (
      <div className={classes.StepOne}>
        <StepHeader
          hideHeader={false}
          headerText={strings.startMeeting}
          subheaderText={strings.weNeedInfo}
          activeStep={1}
          pageCount={5}
        />
        <div className={classes.ContentWrapper}>
          <div className={classes.RadioGroupWrapper}>{content}</div>
          <div className={classes.Footer}>
            <Button
              clicked={this.props.goToStep.bind(this, 2)}
              disabled={this.props.getConfig.status !== 'success'}
            >
              {strings.next}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegister/Steps/GenderStep/GenderStep.js